import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosIntegration from "../../Common/Axios/axiosIntegration";
import Cookies from 'js-cookie';
import API from "../../Common/Endpoint/serviceConstrants";



export const validateLoginTokenUpdated = createAsyncThunk('validateLoginTokenUpdated', async (payload) => {
  try {
    const response = await axiosIntegration.post(API.validate_login_token, payload,{
      headers:{
        clientCode:payload?.clientCode,
        partnerCode:payload?.partnerCode
      }
    })
    return response
  } catch (error) {
    throw new Error('Failed to validate token');
  }
});


export const validateLoginTokenSlice = createSlice({
  name: "validateLoginToken",
  initialState: {
    isLoading: false,
    isError: false,
    data: {},
    error: {},
    message: "",
    isUsed: null,
  },
  reducers: {
    onValidateLoginTokenSubmit: (state) => {
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: {},
        message: "",
        isUsed:null
      };
    },

    onValidateLoginTokenSuccess: (state, { payload }) => {
      const { data = {}, message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        isError: false,
        data,
        message,
        status_code,
      };
    },

    onValidateLoginTokenError: (state, { payload }) => {
      const { data = {}, message = "", status_code = 400 } = payload;
      return {
        ...state,
        data,
        message,
        status_code,
        isLoading: false,
        isError: true,
      };
    },
    onValidateLoginTokenReset: (state) => {
      return {
        ...state,
        message: "",
        data: {},
        status_code: null,
        isLoading: false,
        isError: false,
      };
    },
    onValidateLoginTokenResetNull: (state) => {
      return {
        ...state,
        isUsed: true,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateLoginTokenUpdated.pending, (state, action) => {
        sessionStorage.setItem("postLoginSuccesCount", 1);
        state.isLoading = true;
      })
      .addCase(validateLoginTokenUpdated.fulfilled, (state, action) => {
        let finalData = {...action.payload?.data?.response};
        Cookies.set('xid', finalData?.encryptedMemberIdentifier, { expires: 7 }); // Expires in 7 days
        return {
          ...state,
          isLoading: false,
          data: finalData,
          error: null,
        };
      })
      .addCase(validateLoginTokenUpdated.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action?.message;
      });
  }
});
export const {
  onValidateLoginTokenSubmit,
  onValidateLoginTokenSuccess,
  onValidateLoginTokenError,
  onValidateLoginTokenReset,
  onValidateLoginTokenResetNull,
} = validateLoginTokenSlice.actions;

export default validateLoginTokenSlice.reducer;
